import React, { useContext } from "react"

const VideoCard = ({ title, src, artist }) => {
  return (
    <>
      {src && (
        <div className="video-card">
          <div className="iframe">
            <iframe
              src={`https://www.youtube.com/embed/${src}?controls=0`}
              frameBorder="0"
            ></iframe>
          </div>
          <div className="more">
            <div className="song-info">
              <div className="title">
                <h1>
                  Song Name: <span>{title}</span>
                </h1>
                <h3>
                  Artist: <span>{artist}</span>
                </h3>
              </div>
              <div className="btns">
                <a
                  href={`https://youtu.be/${src}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on youtube
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default VideoCard
